/// <reference path="../../typings/index.d.ts" />

module monitoringApp.components  {
    class StatusComponent implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public template: string;
        
        constructor() {
            this.bindings = {
                status: "=",
                statusText: "="
            };
            this.template =
                `<div>
                <md-icon  ng-show="[[ $ctrl.status==1 ]]">schedule</md-icon> 
            <md-icon class="rotate" ng-show="[[ $ctrl.status==2 ]]" class="blue-gray">remove</md-icon> 
            <md-icon ng-show="[[ $ctrl.status==3 ]]" class="green">check</md-icon> 
            <md-icon ng-show="[[ $ctrl.status==4 ]]" class="red">close</md-icon> 
            <md-icon ng-show="[[ $ctrl.status==5 ]]" class="red">close</md-icon> 
            <div>[[ $ctrl.statusText ]]</div></div>`;
        }
    }

    angular.module("ultimateMonitoringApp").component("statusComponent", new StatusComponent());
}